import { render } from "./TransferSdkKey.vue?vue&type=template&id=7ca074d0"
import script from "./TransferSdkKey.vue?vue&type=script&lang=js"
export * from "./TransferSdkKey.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__